import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-wizard-header',
  templateUrl: './wizard-header.component.html'
})
export class WizardHeaderComponent {
  @Input() logoPath = '';
  @Input() logoText = '';
  @Input() headline = '';
  @Input() tagline = '';
  @Input() stagePosition = 0;
  @Input() totalStages = 0;
}